// extracted by mini-css-extract-plugin
export var actionText = "_ii-4";
export var container = "_ii-0";
export var leftSection = "_ii-1";
export var rightSection = "_ii-2";
export var settingsButton = "_ii-6";
export var settingsIcon = "_ii-7";
export var shortcut = "_ii-5";
export var shortcutGroup = "_ii-3";